import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import { map } from 'rxjs/operators';
import {PoliticasRetanqueoProductos} from '../_models/politicas-retanqueo-productos';
import {PoliticaPerfil} from '../_models/politica-perfil';

@Injectable({
  providedIn: 'root'
})
export class PoliticasRetanqueoProductosService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + "/api/politicasRetanqueoProductos";
  constructor(private httpClient: HttpClient, private autServicio: AutenticacionService) { }

  listadoPoliticaRetanqueoHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as PoliticasRetanqueoProductos[]));
  }

  listadoPorPolitica(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/politica/" + id + "/enabled")
      .pipe(map((res) => res as PoliticasRetanqueoProductos[]));
  }

  crear(regCrear: PoliticasRetanqueoProductos) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as PoliticasRetanqueoProductos));
  }

  actualizar(regActualizar: PoliticasRetanqueoProductos) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as PoliticasRetanqueoProductos));
  }

  bulk(lista: PoliticasRetanqueoProductos[]) {
    lista.map((s: PoliticasRetanqueoProductos) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + "/bulk", lista)
      .pipe(map((res) => res as PoliticasRetanqueoProductos[]));
  }

}
